import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { Identifiable, CalendarExportLink } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  links: Identifiable<CalendarExportLink>[];
  retrieveCalendarExportLinks(
    request: Boundaries["retrieveCalendarExportLinks"]["request"],
  ): void;
}

function useRetrieveCalendarExportLinks(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveCalendarExportLinksRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveCalendarExportLinksRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveCalendarExportLinksRequestFailure,
    ),
    links: useSelector(selector.getCalendarExportLinks),
    retrieveCalendarExportLinks: core.retrieveCalendarExportLinks,
  };
}

export { useRetrieveCalendarExportLinks };
